import Icon from 'flarum/common/components/Icon';
import Modal from 'flarum/common/components/Modal';
import app from 'flarum/forum/app';
import { parseLinkGuardTarget } from '../utils/linkGuardUrl';
import warningContent from '../utils/warningContent';
export default class LinkGuardModal extends Modal {
  className() {
    return 'LinkGuardModal';
  }
  title() {
    return parseLinkGuardTarget(this.attrs.targetHash) ? warningContent().title : app.translator.trans('ffans-link-guard.forum.invalid_title');
  }
  inner() {
    return m('[', null, m("div", {
      className: "LinkGuardModal-heading"
    }, m("span", {
      className: "LinkGuardModal-symbol",
      "aria-hidden": "true"
    }, m(Icon, {
      name: "fas fa-arrow-up-right-from-square"
    })), m("h3", null, this.title())), this.content());
  }
  content() {
    const target = parseLinkGuardTarget(this.attrs.targetHash);
    return m("div", {
      className: "LinkGuardModal-body"
    }, m("p", {
      className: "LinkGuardModal-message"
    }, target ? warningContent().message : app.translator.trans('ffans-link-guard.forum.invalid_message')), target && m("dl", {
      className: "LinkGuardModal-destination"
    }, m("dt", null, app.translator.trans('ffans-link-guard.forum.destination_label')), m("dd", {
      className: "LinkGuardModal-host",
      dir: "ltr"
    }, target.host), m("dd", {
      className: "LinkGuardModal-url",
      dir: "ltr"
    }, target.href)), m("div", {
      className: "LinkGuardModal-actions"
    }, m("button", {
      className: "Button Button--outline",
      type: "button",
      onclick: () => this.hide()
    }, app.translator.trans('ffans-link-guard.forum.cancel_button')), target && m("a", {
      className: "Button Button--primary",
      href: target.href,
      target: "_blank",
      rel: "nofollow noopener noreferrer external",
      "data-ffans-link-guard-bypass": "1",
      onclick: () => this.hide()
    }, app.translator.trans('ffans-link-guard.forum.continue_button'))));
  }
}
flarum.reg.add('ffans-link-guard', 'forum/components/LinkGuardModal', LinkGuardModal);